(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Reveals ---------- */
  var scrollDriven = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  var revealables = document.querySelectorAll('.rv, .pain, .path-wrap');
  if (scrollDriven) {
    // el CSS ya maneja el reveal atado al scroll; sólo se marca el trazado
    document.querySelectorAll('.path-wrap').forEach(function(el){ el.classList.add('in'); });
  } else if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        var sibs = Array.prototype.slice.call(el.parentNode.children).filter(function(n){
          return n.classList && (n.classList.contains('rv') || n.classList.contains('pain'));
        });
        var i = Math.max(0, sibs.indexOf(el));
        setTimeout(function(){ el.classList.add('in'); }, Math.min(i, 5) * 55);
        io.unobserve(el);
      });
    }, { threshold: 0, rootMargin: '0px 0px 18% 0px' });   // dispara ANTES de entrar
    revealables.forEach(function(el){ io.observe(el); });
  } else {
    revealables.forEach(function(el){ el.classList.add('in'); });
  }

  /* ---------- 2. Trazado del método ---------- */
  var pathEl = document.querySelector('.path-rail path');
  if (pathEl) {
    pathEl.style.setProperty('--len', pathEl.getTotalLength());
    if (reduce) pathEl.style.strokeDashoffset = 0;
  }

  /* ---------- 3. Countdown (15:00 por sesión, honesto) ---------- */
  var navClock = document.getElementById('cd-nav');
  var clocks = [navClock].filter(Boolean);   // el countdown vive sólo en la barra superior
  var left = 15 * 60;
  function paint(){
    var m = Math.floor(left/60), s = left % 60;
    var t = (m<10?'0':'')+m+':'+(s<10?'0':'')+s;
    clocks.forEach(function(n){ n.textContent = t; });
    if (navClock) navClock.classList.toggle('hot', left <= 300);
  }
  paint();
  var tick = setInterval(function(){
    if (--left <= 0) { left = 0; paint(); clearInterval(tick); return; }
    paint();
  }, 1000);

  /* ---------- 4. Cupos — DATO REAL ----------
     20 cupos reales que Lautaro descuenta en tiempo real. Acá SOLO se pinta
     el valor que llega en los data-attributes; no se inventa ni se decrementa
     solo. En Shopify: data-left="{{ product.metafields.custom.cupos_restantes }}" */
  document.querySelectorAll('[data-cupos]').forEach(function(box){
    // el tono sube solo cuando el número real baja: no hay nada inventado
    var _l = parseInt(box.getAttribute('data-left'), 10);
    if (isFinite(_l) && _l <= 7) box.classList.add('pocos');
    // el mismo dato real, replicado en la barra fija
    if (isFinite(_l)) {
      var _d = document.querySelector('[data-dock-cupos]');
      if (_d) { _d.textContent = 'Quedan ' + _l + ' cupos'; _d.hidden = false; }
    }
    var fill = box.querySelector('[data-fill]');
    if (!fill) return;
    var pct = parseFloat(fill.getAttribute('data-pct')) || 0;
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) { fill.style.width = pct + '%'; o.unobserve(e.target); } });
      }, { threshold: 0.35 });
      o.observe(box);
    } else { fill.style.width = pct + '%'; }
  });

  /* ---------- 5. Testimonios: arrastre con inercia ---------- */
  document.querySelectorAll('[data-drag]').forEach(function(rail){
    var down=false, startX=0, startScroll=0, lastX=0, v=0, raf=null, moved=false;
    function glide(){ if (Math.abs(v)<0.4) return; rail.scrollLeft += v; v *= 0.94; raf = requestAnimationFrame(glide); }
    rail.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'touch') return;
      down=true; moved=false; startX=lastX=e.clientX; startScroll=rail.scrollLeft; v=0;
      if (raf) cancelAnimationFrame(raf);
      rail.classList.add('dragging'); rail.setPointerCapture(e.pointerId);
    });
    rail.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      rail.scrollLeft = startScroll - dx;
      v = (lastX - e.clientX) * 0.9; lastX = e.clientX;
    });
    function release(e){
      if (!down) return;
      down=false; rail.classList.remove('dragging');
      try { rail.releasePointerCapture(e.pointerId); } catch(_) {}
      if (!reduce) glide();
    }
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('pointerleave', release);
    rail.addEventListener('click', function(e){ if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------- 6. Bonos: rueda ----------
     El giro y la contrarrotación los hace el CSS. Acá sólo se lee, 5 veces
     por segundo, en qué punto va la animación para saber qué libro está
     arriba y actualizar el detalle. Nada de requestAnimationFrame: no compite
     con el scroll. */
  var stage = document.getElementById('wheel-stage');
  var wheel = document.getElementById('wheel');
  var wcap  = document.getElementById('wheel-caption');
  var wdots = document.getElementById('wheel-dots');
  if (stage && wheel && wcap) {
    var DATA = [{"kick": "Producto principal", "title": "Guía Manos al Oficio + Video real", "desc": "82 páginas con diagramas paso a paso, más el video real de una instalación completa.", "val": "<span class=\"was\">$40.000</span> Hoy <b>$19.999</b>", "main": true}, {"kick": "Arrancás sin gastar de más", "title": "Lista de herramientas esenciales", "desc": "Qué herramientas necesitás para empezar a trabajar como instalador.", "val": "<span class=\"was\">$15.000</span> <span class=\"free\">Gratis</span>", "main": false}, {"kick": "No te olvidás de nada", "title": "Checklist de instalación", "desc": "Paso a paso imprimible para no saltearte nada en cada trabajo.", "val": "<span class=\"was\">$15.000</span> <span class=\"free\">Gratis</span>", "main": false}, {"kick": "Evitás los errores más caros", "title": "Guía de errores frecuentes", "desc": "Los errores más comunes y cómo evitarlos, para no perder tiempo ni dinero.", "val": "<span class=\"was\">$15.000</span> <span class=\"free\">Gratis</span>", "main": false}, {"kick": "Sabés qué cobrar", "title": "Cómo calcular presupuestos", "desc": "Materiales, tiempos y mano de obra: cobrá lo justo y ganá más.", "val": "<span class=\"was\">$15.000</span> <span class=\"free\">Gratis</span>", "main": false}, {"kick": "Presupuestás en minutos", "title": "Plantilla de presupuesto", "desc": "Plantilla editable lista para usar con tus futuros clientes.", "val": "<span class=\"was\">$15.000</span> <span class=\"free\">Gratis</span>", "main": false}, {"kick": "Conseguís tu primer cliente", "title": "Guía para conseguir tus primeros clientes", "desc": "Estrategias simples y efectivas para conseguir tus primeros trabajos.", "val": "<span class=\"was\">$15.000</span> <span class=\"free\">Gratis</span>", "main": false}];
    var n = DATA.length, front = -1;

    function paintBook(i){
      if (i === front) return;
      front = i;
      var d = DATA[i];
      wcap.classList.add('swap');
      setTimeout(function(){
        wcap.querySelector('.inner').innerHTML =
          '<div class="wheel-kick">' + d.kick + '</div>' +
          '<h4>' + d.title + '</h4>' +
          '<p>' + d.desc + '</p>' +
          '<span class="wheel-val' + (d.main ? ' main' : '') + '">' + d.val + '</span>';
        wcap.classList.remove('swap');
      }, 180);
      if (wdots) {
        var dots = wdots.children;
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('on', k === i);
      }
    }
    paintBook(0);

    if (!reduce) {
      var timer = null;
      function look(){
        var anims = wheel.getAnimations ? wheel.getAnimations() : [];
        if (!anims.length) return;
        var a = anims[0];
        // progress ya viene 0..1 dentro de la vuelta y contempla el delay
        // negativo de cada libro; currentTime a secas no.
        var ct = a.effect && a.effect.getComputedTiming ? a.effect.getComputedTiming() : null;
        var prog = ct && ct.progress;
        if (typeof prog !== 'number' || !isFinite(prog)) return;
        // el aro gira -360°: el libro i queda de frente cuando su ángulo
        // propio (i/n de vuelta) compensa lo que giró el aro
        var i = Math.round(prog * n);
        i = ((i % n) + n) % n;
        paintBook(i);
      }
      function on(){ stage.classList.add('live'); if (!timer) timer = setInterval(look, 200); }
      function off(){ stage.classList.remove('live'); if (timer) { clearInterval(timer); timer = null; } }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(es){
          es.forEach(function(e){ e.isIntersecting ? on() : off(); });
        }, { threshold: 0 }).observe(stage);
      } else { on(); }
    } else { stage.classList.add('live'); }
  }

  /* ---------- 6b. Personas viendo ahora ----------
     No se inventa: se pinta SÓLO si llega un número real en data-value.
     Sin fuente real el bloque se oculta, así no se publica un dato falso. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-viewers]'), function(el){
    var api = (el.getAttribute('data-api') || '').trim();
    var num = el.querySelector('[data-live-viewers]');
    var demo = el.hasAttribute('data-demo');

    // Sin endpoint no hay dato: el bloque no se publica con un número inventado.
    if (!api) { if (!demo) el.hidden = true; return; }

    // Un id por pestaña: el servidor cuenta sesiones abiertas, no visitas.
    var sid;
    try {
      sid = sessionStorage.getItem('mao_sid');
      if (!sid) { sid = Math.random().toString(36).slice(2) + Date.now().toString(36);
                   sessionStorage.setItem('mao_sid', sid); }
    } catch (e) { sid = Math.random().toString(36).slice(2); }

    var fails = 0;
    function beat(){
      fetch(api + (api.indexOf('?') < 0 ? '?' : '&') + 'sid=' + encodeURIComponent(sid),
            { method: 'POST', keepalive: true })
        .then(function(r){ return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function(d){
          var n = parseInt(d && d[el.getAttribute('data-mode') || 'hoy'], 10);
          if (!isFinite(n) || n < 1) throw 'sin dato';
          fails = 0;
          el.hidden = false;
          el.removeAttribute('data-demo');
          if (num) { num.textContent = n; num.classList.remove('ph'); }
        })
        .catch(function(){ if (++fails >= 2 && !demo) el.hidden = true; });
    }
    beat();
    setInterval(beat, 20000);
  });

  /* ---------- 6c. Testimonios ----------
     La marquesina se frena con el mouse encima o con el dedo apoyado, y
     tocando una captura se abre ampliada para poder leerla. */
  var band = document.querySelector('[data-testi]');
  if (band) {
    ['mouseenter','pointerdown','touchstart'].forEach(function(ev){
      band.addEventListener(ev, function(){ band.classList.add('hold'); }, {passive:true});
    });
    ['mouseleave','pointerup','pointercancel','touchend','touchcancel'].forEach(function(ev){
      band.addEventListener(ev, function(){ band.classList.remove('hold'); }, {passive:true});
    });

    var zoom = document.createElement('div');
    zoom.className = 'testi-zoom';
    zoom.innerHTML = '<div class="cap">Tocá para cerrar</div>';
    var zimg0 = document.createElement('img');
    zoom.insertBefore(zimg0, zoom.firstChild);
    document.body.appendChild(zoom);
    var zimg = zimg0;
    band.addEventListener('click', function(e){
      var fig = e.target.closest('[data-zoom]');
      if (!fig) return;
      var shot = fig.querySelector('.testi-shot');
      var url = getComputedStyle(shot).backgroundImage.slice(5, -2);
      zimg.src = url;
      zimg.alt = 'Mensaje de ' + fig.dataset.nombre;
      zoom.classList.add('on');
    });
    zoom.addEventListener('click', function(){ zoom.classList.remove('on'); });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') zoom.classList.remove('on');
    });
  }

  /* ---------- 6d. Clip de la instalación ----------
     Se reproduce SIEMPRE dentro de su marco. Nada de abrir un reproductor
     encima: la idea es poder seguir leyendo la página con el video andando.
     Arranca mudo y en loop (es lo único que los navegadores dejan hacer
     solos) y el botón prende y apaga el sonido. */
  var btnSon = document.querySelector('[data-sonido]');
  var clip = document.querySelector('.preview-frame video');
  if (btnSon && clip) {
    var marco = clip.parentElement;
    var icPlay = btnSon.querySelector('.ic-play');
    var icSon = btnSon.querySelector('.ic-son');
    var icMudo = btnSon.querySelector('.ic-mudo');

    /* El <video> no puede llevar el data-URI en el src: el reproductor de
       Chromium pide rangos de bytes y data: no los soporta, así que el clip
       queda en readyState 0 y no arranca nunca. Pasándolo a blob anda.
       En Shopify el data-src ya viene como URL de asset y se usa tal cual. */
    var fuente = clip.getAttribute('data-src') || '';
    /* BUG que tuve: montar() marcaba "montado" apenas entraba y recién
       después hacía el fetch. Si el observer lo disparaba y el usuario tocaba
       el botón mientras la conversión seguía en curso, el segundo llamado
       volvía al instante con el <video> todavía SIN src, y el play() no hacía
       nada. Guardando la promesa, cualquier llamado espera al mismo montaje. */
    var montaje = null;
    function montar(){
      if (montaje) return montaje;
      vigilar();
      montaje = new Promise(function(listo){
        if (fuente.slice(0, 5) !== 'data:') { clip.src = fuente; listo(); return; }
        fetch(fuente).then(function(r){ return r.blob(); }).then(function(b){
          clip.src = URL.createObjectURL(b); listo();
        }).catch(function(){ clip.src = fuente; listo(); });
      });
      return montaje;
    }

    /* Si el clip no se puede reproducir —códec, iframe con permisos
       recortados, lo que sea— queda el póster, que es un fotograma real, y se
       esconde el botón: mejor una captura limpia que un play que no hace nada. */
    function soloCaptura(){
      btnSon.hidden = true;
      marco.classList.remove('sonando');
    }
    clip.addEventListener('error', soloCaptura);
    // Hay entornos —un iframe con permisos recortados, por ejemplo— donde el
    // video ni siquiera llega a dar error: simplemente no carga nunca. Si a
    // los 6 segundos no hay ni metadata, queda el póster solo, que es un
    // fotograma real, y se esconde el botón para no ofrecer un play muerto.
    // BUG que tuve: el reloj arrancaba al cargar la página. Con preload="none"
    // el clip está en readyState 0 hasta que alguien lo monta, así que a los 6
    // segundos escondía el botón de un video que todavía nadie había pedido.
    // Ahora el reloj arranca recién cuando se pide el clip.
    var vigilado = false;
    function vigilar(){
      if (vigilado) return; vigilado = true;
      setTimeout(function(){ if (clip.readyState === 0) soloCaptura(); }, 6000);
    }

    function pintar(){
      var son = !clip.muted;
      marco.classList.toggle('sonando', son);
      icPlay.hidden = son;
      icSon.hidden = !son;
      icMudo.hidden = true;
      btnSon.setAttribute('aria-label', son ? 'Silenciar el video' : 'Activar el sonido del video');
    }

    btnSon.addEventListener('click', function(){
      montar().then(function(){
        if (clip.muted) {
          clip.muted = false;
          if (clip.currentTime > 0.5) clip.currentTime = 0;
        } else {
          clip.muted = true;
        }
        var pr = clip.play();
        if (pr && pr.catch) pr.catch(function(){
          // si el entorno no deja sonar, se vuelve a mudo en vez de mentir
          clip.muted = true; pintar();
        });
        pintar();
      });
    });
    btnSon.addEventListener('mouseenter', function(){
      if (!clip.muted) { icSon.hidden = true; icMudo.hidden = false; }
    });
    btnSon.addEventListener('mouseleave', pintar);

    /* fuera de pantalla no tiene sentido que siga corriendo — y si sonaba,
       se silencia para no dejar audio de fondo mientras se lee otra cosa */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting) {
            montar().then(function(){ clip.play().catch(function(){}); });
          } else {
            clip.pause();
            if (!clip.muted) { clip.muted = true; pintar(); }
          }
        });
      }, { threshold: 0 }).observe(clip);
    } else {
      montar().then(function(){ clip.play().catch(function(){}); });
    }
  }

  /* ---------- 7. Scroll suave SÓLO en los anchors ----------
     Antes estaba en html{scroll-behavior:smooth}, que se lo aplica también al
     scroll del usuario y hace que un gesto largo siga deslizando de más. */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---------- 8. Dock móvil ---------- */
  var dock = document.getElementById('dock');
  var heroEl = document.querySelector('.hero');
  if (dock && heroEl && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(es){
      es.forEach(function(e){ dock.classList.toggle('up', !e.isIntersecting); });
    }, { threshold: 0 }).observe(heroEl);
  } else if (dock) { dock.classList.add('up'); }
})();
